<template>
  <div class="empty-cart-w">
    <div class="empty-cart">
    <Icon name="grCart" width="36" class="mb-3"/>
    <div class="mb-5">
      <h1 class="empty-cart__title mb-2">{{ $t('pages.checkout.empty_cart') }}</h1>
      <h4 class="empty-cart__subtitle">{{ $t('pages.checkout.checkins_list_text') }}</h4>
    </div>
    <div>
      <router-link :to="{ name: 'checkins-list'}" class="btn btn-primary">
        {{ $t('menu.checkins_list') }}
      </router-link>
    </div>
  </div>
  </div>

</template>

<script>
export default {
  name: "CheckoutEmptyCart",
}
</script>
